/* global $ */

$(function() {
    "use strict";

    $("form").areYouSure();
});
